// extracted by mini-css-extract-plugin
module.exports = {"collectionStats":"collectionStats_collectionStats__OGzMD","collectionStats__item":"collectionStats_collectionStats__item__NTTyH"};